import React, { FC } from 'react';
import { View, Text } from 'react-native';
import LinkBase from '../../base/LinkBase';
import styles from './styles';

export type LinkProps = {
  /**
   * Optional containerStyle override
   */
  containerStyle?: any;
  /**
   * Link text
   */
  text: string;

  /**
   * Optional textStyle override
   */
  textStyle?: any;

  /**
   * onHover handler
   */
  onHover?: (e: any) => void;

  /**
   * onPress click handler
   */
  onPress: (e: any) => void;

  /**
   * Optional Url parameter
   */
  url?: any;
};

export const Link: FC<LinkProps> = (props) => {
  const { containerStyle, onHover, onPress, text, textStyle, url } = props;
  return (
    <LinkBase
      accessibilityRole="link"
      onHover={onHover}
      onPress={onPress}
      url={url}
    >
      <View style={[styles.container, containerStyle]}>
        <Text style={[styles.textStyle, textStyle]}>{text}</Text>
      </View>
    </LinkBase>
  );
};

export default Link;
